import React from 'react';
import { Row,FormGroup,Col } from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import Logo from '../../Helper/Logo/logo';
import { withStyles } from '@material-ui/core/styles';

const styles={
    Button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },
};
const TrialSection=(props)=> {
    const {classes} = props;
        return(
            <section className="container">
                <Row className="show-grid">
                    <Col xs={12} md={12} sm={6}>
                        <div className="text-center ubme-logo">
                            <Logo/>
                        </div>
                        <div>
                            <h2 className='subHeading'>Get started with a free 30 day trial to UBMe!</h2>
                            <ul className="list">
                                <li>Join thousands of people and businesses who enjoy supporting local, eating local, shopping local and spending time getting familiar with their local community.
                                </li>
                                {/*<li>Keep your employees safe and perform customer service while adhering to social distancing guidelines.*/}
                                {/*</li>*/}
                                <li>No contract. Cancel risk free anytime.
                                </li>
                            </ul>
                            <FormGroup className="text-right mt-30 hidden-md-text-right">
                                <Button  className={classes.Button}
                                         color={'primary'}
                                         variant={'contained'}
                                         onClick={()=>props.next(props.data)} >Start Your Free Month</Button>
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </section>
        )
};
export default withStyles(styles)(TrialSection);